import React from 'react'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'

type DetailProps = {
  title?: string
  open: boolean
  onClose: () => void
  children?: React.ReactNode
}

const ImageDialog = ({ title, open, onClose, children }: DetailProps) => {
  const displayTheme = useDisplayTheme()

  return (
    <Dialog mode={displayTheme} open={open} onClose={onClose} disableBackdropClick width="700px">
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <Dialog.DialogContent width="700px">{children}</Dialog.DialogContent>
      <Dialog.DialogActions />
    </Dialog>
  )
}

export default ImageDialog
